import { get, isEmpty } from 'lodash'
import { Box, Grid, Typography } from '@mui/material'

// import { ProgressBar } from 'components'
import { t } from 'i18n'
import { TeamInsightsProps } from '../TeamInsightsComponent/TeamInsightsComponent'
import { formatToUSD } from 'utils/currency'
import { capitalize } from 'lodash'

export default function TeamInsightsRewardBudgetProgress(
  props: TeamInsightsProps,
) {
  const { insights, insightsMeta } = props

  if (!isEmpty(insights)) {
    const spent =
      get(insights, 'budget.budget_recognition') &&
      get(insights, 'budget.budget_recognition').reduce(
        (acc, value) => acc + +value.budget.spent,
        0,
      )

    // const available = get(insights, 'budget.available') && parseFloat(get(insights, 'budget.available'))
    const maxEmployeeRewardAmount = get(insights, 'budget.max_employee_reward_amount') && parseFloat(get(insights, 'budget.max_employee_reward_amount'))
    const budgetPeriod = get(insights, 'budget.period') && get(insights, 'budget.period')
    const teamMembers = get(insightsMeta, 'my_team_members') && get(insightsMeta, 'my_team_members')
    const teamCount = teamMembers.length
    const totalAmount = (maxEmployeeRewardAmount * teamCount)
    // const percentageSpent = Math.round((spent * 100) / (totalAmount))
    
    return (
      <Grid container>
        <Grid item xs={12}>
          <Box mb={2} width={1}>
            <Grid item xs={12}>
              <Grid container justifyContent='space-between'>
                {[
                  {
                    id: 'available',
                    label: t('insights.team.rewardBudgetProgressLabels.total', { period: capitalize(budgetPeriod) }),
                    // value: available,
                    value: totalAmount,
                    align: 'left',
                  },
                  {
                    id: 'spent',
                    label: t('insights.team.rewardBudgetProgressLabels.spent'),
                    value: spent,
                    align: 'right',
                  },
                ].map((legend: any) => (
                  <Grid item key={legend.id}>
                    <Grid container direction='column'>
                      <Typography
                        variant='body1'
                        color='text.secondary'
                        fontWeight={600}
                        fontSize={14}
                        align={legend.align}
                      >
                        {legend.label}
                      </Typography>

                      <Typography
                        variant='body1'
                        color='secondary.main'
                        fontWeight={600}
                        align={legend.align}
                      >
                        {formatToUSD(legend.value)}
                      </Typography>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* <Grid item xs={12}>
              <ProgressBar
                labelVariant='h6'
                showLabel
                progress={[
                  {
                    percentage: (percentageSpent >= 100) ? 100 : percentageSpent,
                    color: 'secondary',
                  },
                ]}
              />
            </Grid> */}
          </Box>

          {get(insights, 'budget.budget_recognition', []).map((item, index) => (
            <Grid container justifyContent='space-between' key={index}>
              <Typography variant='body2' color='text.secondary' paragraph>
                {item.name}
              </Typography>

              <Typography
                variant='body2'
                color='text.primary'
                fontWeight={700}
                paragraph
              >
                {formatToUSD(item.budget.spent)}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
    )
  }

  return null
}
